require('./index.js');
require('./miq-button.js');
